import React from "react";
import { Tag, Tooltip } from "antd";
import {
  CheckCircleOutlined,
  WarningOutlined,
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

/**
 * Reusable traffic-light badge for material-fulfillment status.
 *
 * Statuses (from API Guide §9):
 *  - fulfilled    → 🟢 all materials available
 *  - partial      → 🟡 some materials available
 *  - unfulfilled  → 🔴 not available (also covers "critical")
 *  - pending      → 🔵 MRP not yet run
 */
const statusConfig = {
  fulfilled: {
    color: "green",
    icon: <CheckCircleOutlined />,
    label: "All Materials Ready",
  },
  partial: {
    color: "orange",
    icon: <ExclamationCircleOutlined />,
    label: "Partial Materials Available",
  },
  unfulfilled: {
    color: "red",
    icon: <CloseCircleOutlined />,
    label: "Materials Not Available",
  },
  critical: {
    color: "red",
    icon: <WarningOutlined />,
    label: "Critical — Materials Missing",
  },
  pending: {
    color: "blue",
    icon: <QuestionCircleOutlined />,
    label: "MRP Not Run",
  },
};

const FulfillmentBadge = ({ status, showLabel = false }) => {
  const config = statusConfig[status] || statusConfig.pending;

  return (
    <Tooltip title={config.label}>
      <Tag color={config.color} icon={config.icon}>
        {showLabel ? config.label : (status || "pending").toUpperCase()}
      </Tag>
    </Tooltip>
  );
};

export default FulfillmentBadge;
